export default __webpack_public_path__ + "static/media/1.70b35b0a.jpg";